import SHA256 from 'crypto-js/sha256';
import { EMAIL_REGEX } from '@zoopla/shared/forms';
import Cookies from 'js-cookie';

const DaysToExpiry = 30; // 30 days as this is how long a user stays signed in for.

const isValidEmail = (email: string) => EMAIL_REGEX.test(email);

// ATS (Authenticated Traffic Solution) provides a people-based identifier throughout the programmatic Ad supply chain.
export const liverampAts = (email: string) => {
    // Format email as per LiveRamp's requirements https://docs.liveramp.com/privacy-manager/en/implement-ats-via-console.html#configure-advanced-settings-for-detect-mode
    const formattedEmail = email.toLowerCase().trim();

    if (!isValidEmail(formattedEmail)) {
        return;
    }

    const sha256HashedEmail = SHA256(formattedEmail).toString();

    // Note: A cookie is stored with the information needed by LiveRamp ATS.
    // AdBridg (Zoopla's ad partner) will detect this cookie and make the request to ATS themselves.
    // This is so that they can fit the ATS request seamlessly into their ad workflow, reducing latency to serve ads.
    Cookies.set('adb_he', sha256HashedEmail, {
        expires: DaysToExpiry,
        secure: true,
        sameSite: 'strict'
    });
};
